/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const PENDING_COMMUNICATION_BEGIN = 'PENDING_COMMUNICATION_BEGIN';
export const PENDING_COMMUNICATION_SUCCESS = 'PENDING_COMMUNICATION_SUCCESS';
export const PENDING_COMMUNICATION_FAILURE = 'PENDING_COMMUNICATION_FAILURE';
export const CLEAR_PENDING_COMMUNICATION = 'CLEAR_PENDING_COMMUNICATION';

export const FINISHED_COMMUNICATION_BEGIN = 'FINISHED_COMMUNICATION_BEGIN';
export const FINISHED_COMMUNICATION_SUCCESS = 'FINISHED_COMMUNICATION_SUCCESS';
export const FINISHED_COMMUNICATION_FAILURE = 'FINISHED_COMMUNICATION_FAILURE';
export const CLEAR_FINISHED_COMMUNICATION = 'CLEAR_FINISHED_COMMUNICATION';

export const COMUNICATION_PROGRAM_BY_ID_BEGIN = 'COMUNICATION_PROGRAM_BY_ID_BEGIN';
export const COMUNICATION_PROGRAM_BY_ID_SUCCESS = 'COMUNICATION_PROGRAM_BY_ID_SUCCESS';
export const COMUNICATION_PROGRAM_BY_ID_FAILURE = 'COMUNICATION_PROGRAM_BY_ID_FAILURE';
export const CLEAR_COMUNICATION_PROGRAM_BY_ID = 'CLEAR_COMUNICATION_PROGRAM_BY_ID';

export const COMUNICATION_PROGRAM_SUMMARY_BEGIN = 'COMUNICATION_PROGRAM_SUMMARY_BEGIN';
export const COMUNICATION_PROGRAM_SUMMARY_SUCCESS = 'COMUNICATION_PROGRAM_SUMMARY_SUCCESS';
export const COMUNICATION_PROGRAM_SUMMARY_FAILURE = 'COMUNICATION_PROGRAM_SUMMARY_FAILURE';
export const CLEAR_COMUNICATION_PROGRAM_SUMMARY = 'CLEAR_COMUNICATION_PROGRAM_SUMMARY';

export const SPECIALITY_SUMMARY_BEGIN = 'SPECIALITY_SUMMARY_BEGIN';
export const SPECIALITY_SUMMARY_SUCCESS = 'SPECIALITY_SUMMARY_SUCCESS';
export const SPECIALITY_SUMMARY_FAILURE = 'SPECIALITY_SUMMARY_FAILURE';
export const CLEAR_SPECIALITY_SUMMARY = 'CLEAR_SPECIALITY_SUMMARY';

export const SYSTEM_SUMMARY_BEGIN = 'SYSTEM_SUMMARY_BEGIN';
export const SYSTEM_SUMMARY_SUCCESS = 'SYSTEM_SUMMARY_SUCCESS';
export const SYSTEM_SUMMARY_FAILURE = 'SYSTEM_SUMMARY_FAILURE';
export const CLEAR_SYSTEM_SUMMARY = 'CLEAR_SYSTEM_SUMMARY';

export const COMPLIANCE_ADVANCE_BEGIN = 'COMPLIANCE_ADVANCE_BEGIN';
export const COMPLIANCE_ADVANCE_SUCCESS = 'COMPLIANCE_ADVANCE_SUCCESS';
export const COMPLIANCE_ADVANCE_FAILURE = 'COMPLIANCE_ADVANCE_FAILURE';
export const CLEAR_COMPLIANCE_ADVANCE = 'CLEAR_COMPLIANCE_ADVANCE';
export const CLEAR_ALL = 'CLEAR_ALL';

export const END_COMMUNICATION_BEGIN = 'END_COMMUNICATION_BEGIN';
export const END_COMMUNICATION_SUCCESS = 'END_COMMUNICATION_SUCCESS';
export const END_COMMUNICATION_FAILURE = 'END_COMMUNICATION_FAILURE';

export const QUALIFICATION_PROCESS = 'QUALIFICATION_PROCESS';

export const INSUPD_SEND_EMAIL_REQUEST = 'INSUPD_SEND_EMAIL_REQUEST'
export const INSUPD_SEND_EMAIL_SUCCESS = 'INSUPD_SEND_EMAIL_SUCCESS'
export const INSUPD_SEND_EMAIL_FAIL = 'INSUPD_SEND_EMAIL_FAIL'


export const timeQuizMedia = (data) => dispatch => {
    ApiService.setQuizVideoSeconds(data).then(
        response => {            
        }
    ).catch(
        (error) => {
        }
    )
}



export function fetchPendingCommunication(param, filter) {
    return async dispatch => {
        dispatch(pendingCommunicationBegin());
        await ApiService.getPendingCommunications(param, filter)
            .then(
                result => {
        
                    dispatch(pendingCommunicationSuccess(result));
                },
                error => {
             
                    dispatch(pendingCommunicationError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchFinishedCommunication(param, filter) {
    return async dispatch => {
        dispatch(finishedCommunicationBegin());
        await ApiService.getFinishedCommunications(param, filter)
            .then(
                result => {
                    dispatch(finishedCommunicationSuccess(result));
                },
                error => {
                    dispatch(finishedCommunicationError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationProgramById(id) {
    return async dispatch => {
        dispatch(CommunicationProgramByIdBegin());
        await ApiService.getCommunicationProgramByEmployeeId(id)
            .then(
                result => {
                    dispatch(CommunicationProgramByIdSuccess(result));
                },
                error => {
                    dispatch(CommunicationProgramByIdError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationProgramSummary(data) {
    return async dispatch => {
        dispatch(CommunicationProgramSummaryBegin());
        await ApiService.getCommunicationProgramSummary(data)
            .then(
                result => {
                    dispatch(CommunicationProgramSummarySuccess(result));
                },
                error => {
                    dispatch(CommunicationProgramSummaryError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchSpecialtySummary(data) {
    return async dispatch => {
        dispatch(SpecialtySummaryBegin());
        await ApiService.getSpecialtySummary(data)
            .then(
                result => {
                    dispatch(SpecialtySummarySuccess(result));
                },
                error => {
                    dispatch(SpecialtySummaryError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchSystemSummary(data) {
    return async dispatch => {
        dispatch(SystemSummaryBegin());
        await ApiService.getSystemSummary(data)
            .then(
                result => {
                    dispatch(SystemSummarySuccess(result));
                },
                error => {
                    dispatch(SystemSummaryError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function endCommunication(data, setResultVisible) {
    return async dispatch => {
        dispatch(endCommunicationBegin())
        await ApiService.endCommunication(data)
            .then(
                result => {
                    dispatch(endCommunicationSuccess());
                    setResultVisible(result.success)
                },
                error => {
                    dispatch(endCommunicationError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }
}

export function fetchComplianceAdvance(data) {
    return async dispatch => {
        dispatch(complianceAdvanceBegin());
        await ApiService.getCommunicationComplianceAdvance(data)
            .then(
                result => {
                    dispatch(complianceAdvanceSuccess(result));
                },
                error => {
                    dispatch(complianceAdvanceError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const programingSendEmail = (idDiffusionCourse, employeeeId, callback) => dispatch => {
    dispatch({ type: INSUPD_SEND_EMAIL_REQUEST });
    ApiService.programingSendEmail(idDiffusionCourse, employeeeId).then(
        response => {
            dispatch({
                type: INSUPD_SEND_EMAIL_SUCCESS,
                payload: "El empleado con ficha " + employeeeId + " será notificado vía email"
            });

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => dispatch({ type: INSUPD_SEND_EMAIL_FAIL, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export function qualificationProccessSuccess(data) {
    qualificationProccess(data);
}

export const pendingCommunicationBegin = () => ({
    type: PENDING_COMMUNICATION_BEGIN,
});

export const pendingCommunicationSuccess = data => ({
    type: PENDING_COMMUNICATION_SUCCESS,
    payload: { data }
})

export const pendingCommunicationError = () => ({
    type: PENDING_COMMUNICATION_FAILURE,
})
export const clearPendingCommunication = () => ({
    type: CLEAR_PENDING_COMMUNICATION,
});

//FINISHED COMMUNICATIONS
export const finishedCommunicationBegin = () => ({
    type: FINISHED_COMMUNICATION_BEGIN,
});

export const finishedCommunicationSuccess = data => ({
    type: FINISHED_COMMUNICATION_SUCCESS,
    payload: { data }
})

export const finishedCommunicationError = () => ({
    type: FINISHED_COMMUNICATION_FAILURE,
})

export const clearfinishedCommunication = () => ({
    type: CLEAR_FINISHED_COMMUNICATION,
});

//CommunicationProgram by Employee Id
export const CommunicationProgramByIdBegin = () => ({
    type: COMUNICATION_PROGRAM_BY_ID_BEGIN
});

export const CommunicationProgramByIdSuccess = data => ({
    type: COMUNICATION_PROGRAM_BY_ID_SUCCESS,
    payload: { data }
})

export const CommunicationProgramByIdError = () => ({
    type: COMUNICATION_PROGRAM_BY_ID_FAILURE,
})

export const clearCommunicationProgramById = () => ({
    type: CLEAR_COMUNICATION_PROGRAM_BY_ID,
});

//CommunicationProgramSummary by Employee Id
export const CommunicationProgramSummaryBegin = () => ({
    type: COMUNICATION_PROGRAM_SUMMARY_BEGIN
});

export const CommunicationProgramSummarySuccess = data => ({
    type: COMUNICATION_PROGRAM_SUMMARY_SUCCESS,
    payload: { data }
})

export const CommunicationProgramSummaryError = () => ({
    type: COMUNICATION_PROGRAM_SUMMARY_FAILURE,
})

export const clearCommunicationProgramSummary = () => ({
    type: CLEAR_COMUNICATION_PROGRAM_SUMMARY,
});

//SpecialtySummary by Employee Id
export const SpecialtySummaryBegin = () => ({
    type: SPECIALITY_SUMMARY_BEGIN
});

export const SpecialtySummarySuccess = data => ({
    type: SPECIALITY_SUMMARY_SUCCESS,
    payload: { data }
})

export const SpecialtySummaryError = () => ({
    type: SPECIALITY_SUMMARY_FAILURE,
})

export const clearSpecialtySummary = () => ({
    type: CLEAR_SPECIALITY_SUMMARY,
});

//SystemSummary by Employee Id
export const SystemSummaryBegin = () => ({
    type: SYSTEM_SUMMARY_BEGIN
});

export const SystemSummarySuccess = data => ({
    type: SYSTEM_SUMMARY_SUCCESS,
    payload: { data }
})

export const SystemSummaryError = () => ({
    type: SYSTEM_SUMMARY_FAILURE,
})

export const clearSystemSummary = () => ({
    type: CLEAR_SYSTEM_SUMMARY,
});
//ComplianceAdvance
export const complianceAdvanceBegin = () => ({
    type: COMPLIANCE_ADVANCE_BEGIN
});

export const complianceAdvanceSuccess = data => ({
    type: COMPLIANCE_ADVANCE_SUCCESS,
    payload: { data }
})

export const complianceAdvanceError = () => ({
    type: COMPLIANCE_ADVANCE_FAILURE,
})

export const clearComplianceAdvance = () => ({
    type: CLEAR_COMPLIANCE_ADVANCE,
});

export const clearAll = () => ({
    type: CLEAR_ALL
})


export const endCommunicationBegin = () => ({
    type: END_COMMUNICATION_BEGIN,
});

export const endCommunicationSuccess = () => ({
    type: END_COMMUNICATION_SUCCESS
})

export const endCommunicationError = () => ({
    type: END_COMMUNICATION_FAILURE
})

export const qualificationProccess = data => ({
    type: QUALIFICATION_PROCESS,
    payload: data
})